"use strict";

exports.__esModule = true;
exports.getChainIcon = void 0;
const getChainIcon = name => `https://resource.acala.network/network/${name.toLowerCase()}.png`;
exports.getChainIcon = getChainIcon;